import React from 'react'
import { GridItemProps } from './types'
import FocusableCard from '../Card/FocusableCard'
import { Layout } from '../CarouselTS/types'
import { getCardLayout } from './utils'
import {
  FocusContext,
  KeyPressDetails,
  useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'
import { getGridLayout } from '../Grid/utils'
import {
  secondsToHms,
  secondsToTTS,
  truncate,
} from '../../../../shared/helpers'
import { useNavigate } from 'react-router'

function GridItem({
  content,
  index,
  onArrowPress,
  focusKey: propsFocusKey,
}: GridItemProps) {
  const { ref, focusKey } = useFocusable({
    focusKey: propsFocusKey,
  })
  const layout = getGridLayout()
  const navigate = useNavigate()

  const onArrowPressHandler = (
    direction: string,
    props: { index: number },
    details: KeyPressDetails
  ) => {
    const parentOffsetTop = ref.current?.offsetParent?.offsetTop ?? 0

    return onArrowPress(
      direction,
      { parentOffsetTop, index: props.index },
      details
    )
  }

  const cardLayout = getCardLayout(layout) as Layout

  const { images, title, duration, parent } = content
  const imageUrl =
    images['asset-mezzanine-16x9'] || images['asset-kids-mezzanine1-16x9'] || ''

  const contentTitle = title ? truncate.apply(title, [35, true]) : ''
  const contentDuration = duration ? secondsToHms(duration) : ''

  const onEnterPress = () => {
    if (content.url) {
      const url = encodeURIComponent(content.url)
      navigate(`/video-details/${url}`)
    }
  }

  const noOpFn = () => {}

  let tts = ''
  const episodeNumber = content?.parent?.ordinal ?? null
  const seasonNumber = content?.parent?.season?.ordinal ?? null
  const secondsToTTSAux = secondsToTTS(duration)
  if (content?.parent && content?.parent?.resource_type === 'special') {
    tts = `${title} ... ${parent?.resource_type} ... ${secondsToTTSAux}`
  } else {
    const seasonInfo = `season ${seasonNumber}`
    tts = `${title} ... ${seasonInfo} ... ${parent?.resource_type} ... ${episodeNumber} ... ${secondsToTTSAux}`
  }

  return (
    <FocusContext.Provider value={focusKey}>
      <FocusableCard
        index={index}
        onFocus={noOpFn}
        layout={cardLayout}
        ttsText={tts}
        onEnterPress={onEnterPress}
        className="collection-screen__grid-item"
        onArrowPress={onArrowPressHandler}
      >
        <div className="collection-screen__grid-image-container" ref={ref}>
          {imageUrl && (
            <img
              className="collection-screen__grid-image"
              src={`${imageUrl}?resize=422x240&format=webp`}
              alt={`${title} grid poster`}
            />
          )}
        </div>
        <div className="collection-screen__grid-caption">
          <h3 className="collection-screen__content-title">{contentTitle}</h3>
          <h3 className="collection-screen__content-duration">
            {content.parent.resource_type === 'special'
              ? `Special | ${contentDuration}`
              : `S${seasonNumber} Ep${episodeNumber} | ${contentDuration}`}
          </h3>
        </div>
      </FocusableCard>
    </FocusContext.Provider>
  )
}

export default GridItem
